<template>
  <NuxtLayout
    name="auth"
    ref="layoutRef"
  >
    <div
      v-if="smAndLarger"
      class="flex flex-col items-center m-auto"
    >
      <AppCardMain class="w-104">
        <div class="flex flex-col items-center py-6 px-4 gap-4">
          <img
            :src="errorData.icon"
            alt="Link expires"
            :class="errorData?.classIcon"
          />
          <span
            v-if="errorData.title !== undefined"
            class="text-xl font-bold"
          >
            {{ errorData.title }}
          </span>
          <component
            v-if="errorData.description !== undefined"
            :is="errorData.description"
          ></component>
        </div>
      </AppCardMain>
    </div>
    <div
      v-else
      class="flex flex-col items-center m-auto gap-4"
    >
      <img
        :src="errorData.icon"
        alt="Link expires"
        :class="errorData?.classIcon"
      />
      <span
        v-if="errorData.title !== undefined"
        class="text-xl font-bold"
      >
        {{ errorData.title }}
      </span>
      <component
        v-if="errorData.description !== undefined"
        :is="errorData.description"
      ></component>
    </div>
  </NuxtLayout>
</template>

<script setup lang="ts">
import LinkExpiresIcon from "@/assets/images/linked.svg";
import LineExistsIcon from "@/assets/images/account.svg";
import LargeScreenIcon from "@/assets/images/small_screen.svg";
import type { NuxtError } from "#app";
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";

const breakpoints = useBreakpoints(breakpointsTailwind);
const smAndLarger = breakpoints.greaterOrEqual("sm"); // sm

setPageLayout("auth");

interface Props {
  error: NuxtError;
}

const layoutRef = ref();

const props = defineProps<Props>();

const generateDescriptions = (texts: string[]) => {
  return h(
    "div",
    {
      class:
        "flex flex-col gap-1 items-center text-sm font-medium leading-sm text-text-neutral-lv2",
    },
    texts?.map((x) => h("span", {}, String(x))) || [],
  );
};

const errorData = computed(() => {
  const errorOptions = {
    link_expires: {
      icon: LinkExpiresIcon,
      classIcon: "size-20",
      title: "ลิงก์นี้ใช้งานไม่ได้แล้ว",
      description: generateDescriptions([
        "ลิงก์หมดอายุหรือถูกใช้งานไปแล้ว",
        "กรุณาขอลิงก์ใหม่จากพนักงานขายของคุณ",
      ]),
    },
    link_expires_staff: {
      icon: LinkExpiresIcon,
      classIcon: "size-20",
      title: "ลิงก์นี้ใช้งานไม่ได้แล้ว",
      description: generateDescriptions([
        "ลิงก์หมดอายุหรือถูกใช้งานไปแล้ว",
        "กรุณาขอลิงก์ใหม่จากผู้ดูแลระบบของคุณ",
      ]),
    },
    line_exists: {
      icon: LineExistsIcon,
      classIcon: "size-20",
      title: "มีบัญชีอยู่แล้ว",
      description: generateDescriptions([
        "ไลน์ของคุณสมัครสมาชิกไว้แล้ว กรุณาเข้าสู่ระบบด้วย",
        "บัญชีผู้ใช้และรหัสผ่านที่หน้าเว็บของเรา",
      ]),
    },
    large_screen: {
      icon: LargeScreenIcon,
      classIcon: "w-75",
      title: "ลองใช้งานบนหน้าจอที่ใหญ่ขึ้น",
      description: generateDescriptions([
        "ฟีเจอร์นี้ยังไม่รองรับบนมือถือ",
        "โปรดเปลี่ยนอุปกรณ์เป็นคอมพิวเตอร์เพื่อใช้งานฟีเจอร์",
        "นี้ กรุณาเปลี่ยนไปใช้งานบน Desktop",
        "เพื่อประสบการณ์ที่ดีที่สุด",
      ]),
    },
    default: {
      icon: LinkExpiresIcon,
      classIcon: "size-20",
      title: `Code: ${props.error?.status}`,
      description: generateDescriptions([
        props.error?.statusText || props.error?.message,
      ]),
    },
  };
  console.log(props.error);
  const type = props.error?.data?.["type"] || "default";

  return (
    errorOptions[type as keyof typeof errorOptions] ?? errorOptions.default
  );
});

onMounted(() => {
  layoutRef.value?.layoutRef.setPageType("default");
});
</script>
